import ScrollCarousel from '../ScrollCarousel';

const SELECTORS = {
  viewport: '[data-shoppable-modal-viewport]',
  track: '[data-shoppable-modal-track]',
};

export default () => {
  const slider = document.querySelector('[data-shoppable-modal-products]');
  let carousel = null;
  const carousels = [];

  const create = () => {
    if (!slider || !slider.querySelector(SELECTORS.track)) {
      return null;
    }
    return new ScrollCarousel(slider, {
      selectors: SELECTORS,
      // Flickity `wrapAround: true` and its thin custom arrow shape.
      loop: true,
      arrowShape:
        'M72.796,0.001c-1.314,0.168 -1.563,0.449 -2.17,0.998l-47.051,47.052l47.211,50.818c1.883,1.878 3.088,1.018 4.202,0.262c1.654,-1.123 1.921,-3.596 0.588,-5.185l-42.451,-45.718l42.598,-42.624c1.653,-2.251 0.05,-5.678 -2.927,-5.603Z',
      prevNextButtons: true,
      pageDots: true,
      draggable: true,
      slidesPerView: 1,
      ariaLabel: 'Shoppable products',
    });
  };

  const destroyAll = () => {
    carousels.forEach((_carousel) => {
      _carousel.destroy();
    });
    // Previously the array was never emptied, so every later teardown
    // re-destroyed instances that were already gone.
    carousels.length = 0;
  };

  if (window.theme.breakpoints.current === 'mobile') {
    carousel = create();
    if (carousel) carousels.push(carousel);
  }

  document.addEventListener('shoppableImageDidClose', destroyAll, { once: true });

  window.addEventListener('breakpointChange', () => {
    if (window.theme.breakpoints.current === 'mobile') {
      carousel = create();
      if (carousel) carousels.push(carousel);
    } else {
      destroyAll();
    }
  });
};
